import React from 'react'
import Image from 'components/image/image'
import './block-img-text-number.sass'

const BlockImgTextNumber = ({ data }) => {
  return (
    <section className="BlockImgTextNumber container-fluid">
      <div className={`BlockImgTextNumber__space row ${data.classes && data.classes.container ? data.classes.container : null}`}>
        <div className={`
                        ${data.classes && data.classes.text_block ? data.classes.text_block : null}
                        ${data.image ? 'col-md-5' : 'col-md-12'}`
                        }>
          <div className="d-flex">
            <span className={`BlockImgTextNumber__number mr-3 ${data.classes && data.classes.number_style ? data.classes.number_style : null}`}>
              {data.number}
            </span>
            <h2 className="mt-2">{data.title}</h2>
          </div>
          <p>{data.subtext}</p>
        </div>
        { data.image ?
          <div className="col-md-7 p-0">
            <Image image_url={`content/${data.image}`}
                   className="BlockImgTextNumber__image"
                   alt={`${data.image_alt}`}/>
          </div>
        : null }

      </div>
    </section>
  )
}

export default BlockImgTextNumber
